import React from 'react';
import { utilizationApi } from '../../../services';
import { GraphCard } from '../../common/organisms';
import OverallManagerSA from '../../../managers/SpendingAccount/OverallManagerSA';
class OverallSA extends React.Component {
  state = {
    overallObj: {},
    loading: true,
  };

  componentDidMount() {
    this.fetchOverallData();
  }

  componentWillUnmount() {
    this.props.token && this.props.token.cancel();
  }

  fetchOverallData = () => {
    const { contractId, token } = this.props;
    var promise1 = utilizationApi.healthChecksFetchOverall({ contractId, cancelToken: token.token });
    var promise2 = utilizationApi.healthChecksFetchOverallSavings({ contractId, cancelToken: token.token });
    var promise3 = utilizationApi.healthChecksFetchOverallRatings({ contractId, cancelToken: token.token });
    var promise4 = utilizationApi.healthChecksFetchOverallNetwork({ contractId, cancelToken: token.token });

    Promise.all([promise1, promise2, promise3, promise4]).then((values) => {
      var resp_arr = values.map((resp) => resp.data);
      var overallObj = new OverallManagerSA(resp_arr);
      this.setState({ overallObj, loading: false });
    });
  };

  calculateHeight(data) {
    if (data) {
      let length;
      data.length < 10
        ? (length = data.length === 1 ? '18rem' : data.length * 110 + 'px')
        : (length = data.length * 70 + 'px');
      return length;
    }
  }

  render() {
    const {
      savingsData = {},
      spentData = {},
      overallData = {},
      ratingsData = {},
      networkData = {},
    } = this.state.overallObj;

    const { loading } = this.state;

    return (
      <div className='pt-8'>
        <span className='block font-semibold text-base text-gray-700 mb-3 leading-none'>Spending Account</span>
        <div style={{ height: this.calculateHeight(overallData.data) }}>
          <GraphCard
            loading={loading}
            loaderHeight={200}
            graphprops={{
              id: 'spendingAccountBarGraph',
              data: overallData.data,
              labels: overallData.labels,
              backgroundColor: overallData.barColors,
              type: 'horizontalBar',
              ticks: {
                min: 0,
                max: 4 * overallData.stepSize || 5,
                stepSize: overallData.stepSize || 1,
              },
              xAxesLabel: 'Number of spending account',
              yAxesLabel: 'Contract years',
            }}
            descriptionPoints={overallData.content}
          />
        </div>

        <span className='block font-semibold text-base text-gray-700 mb-3 mt-12 leading-none'>
          Amount spent on sponsored spending account
        </span>
        <div style={{ height: this.calculateHeight(spentData.data) }}>
          <GraphCard
            loading={loading}
            loaderHeight={200}
            graphprops={{
              id: 'spentBarGraph',
              data: spentData.data,
              labels: spentData.labels,
              backgroundColor: spentData.barColors,
              type: 'horizontalBar',
              ticks: {
                min: 0,
                max: 4 * spentData.stepSize || 5,
                stepSize: spentData.stepSize || 1,
              },
              dataPoints: 'rupees',
              xAxesLabel: 'Cost',
              yAxesLabel: 'Contract years',
            }}
            descriptionPoints={spentData.content}
          />
        </div>

        <span className='block font-semibold text-base text-gray-700 mb-3 mt-12 leading-none'>
          Amount saved on sponsored spending account by ekincare
        </span>
        <div style={{ height: this.calculateHeight(savingsData.data) }}>
          <GraphCard
            loading={loading}
            loaderHeight={200}
            graphprops={{
              id: 'savingsBarGraph',
              data: savingsData.data,
              labels: savingsData.labels,
              backgroundColor: savingsData.barColors,
              type: 'horizontalBar',
              ticks: {
                min: 0,
                max: 4 * savingsData.stepSize || 5,
                stepSize: savingsData.stepSize || 1,
              },
              dataPoints: 'rupees',
              xAxesLabel: 'Cost',
              yAxesLabel: 'Contract years',
            }}
            descriptionPoints={savingsData.content}
          />
        </div>

        <span className='block font-semibold text-base text-gray-700 mb-3 mt-12 leading-none'>
          Spending account ratings
        </span>
        <div style={{ height: this.calculateHeight(ratingsData.data) }}>
          <GraphCard
            loading={loading}
            loaderHeight={200}
            graphprops={{
              id: 'ratingsBarGraph',
              data: ratingsData.data,
              labels: ratingsData.labels,
              backgroundColor: ratingsData.barColors,
              type: 'horizontalBar',
              ticks: {
                min: 0,
                max: 5,
                stepSize: ratingsData.stepSize,
              },
              xAxesLabel: 'Ratings',
              yAxesLabel: 'Contract year',
            }}
            descriptionPoints={ratingsData.content}
          />
        </div>

        <span className='block font-semibold text-base text-gray-700 mb-3 mt-12 leading-none'>Network coverage</span>
        <div style={{ height: this.calculateHeight(networkData.data) }}>
          <GraphCard
            loading={loading}
            loaderHeight={200}
            graphprops={{
              id: 'networkBarGraph',
              data: networkData.data,
              labels: networkData.labels,
              backgroundColor: networkData.barColors,
              type: 'horizontalBar',
              ticks: {
                min: 0,
                max: 4 * networkData.stepSize || 5,
                stepSize: networkData.stepSize || 1,
              },
              xAxesLabel: 'Number of centers',
              yAxesLabel: 'Contract years',
            }}
            descriptionPoints={networkData.content}
          />
        </div>
      </div>
    );
  }
}

export default OverallSA;
